import Pointer from "@frog/source/utility/Pointer.js"
import Keyset from "@frog/source/utility/Keyset.js"
import Speedtest from "@frog/source/utility/Speedtest.js"
import Keyb from "keyb"
import Stage from "@frog/source/models/Stage.js"
import Geometry from "@frog/source/utility/Geometry.js"
import clipboard from "copy-to-clipboard"

const MINIMUM_SELECTION_DURATION = 250 // in milliseconds.
const MAXIMUM_HOVERED_POSITIONS = 10

import Audiomix from "@frog/source/models/juice/Audiomix.js"

import sizes from "@frog/source/data/sizes.js"

function calculateRelativePosition({x, y}, camera) {
    if(document.getElementById("frame") == undefined) {
        return {"x": 0, "y": 0}
    }
    const bounds = document.getElementById("frame").getBoundingClientRect()
    window.bounds = bounds
    x = ((x - bounds.left) / bounds.width) * sizes.canvas.width
    y = ((y - bounds.top) / bounds.height) * sizes.canvas.height
    x -= camera.position.x
    y -= camera.position.y

    return {x, y}
}

function convertCartesianToIsometric({x, y}) {
    const isoposition = {
        "x": ((x / (sizes.grid.width / 2)) + (y / (sizes.grid.height / 2))) / 2,
        "y": ((y / (sizes.grid.height / 2)) - (x / (sizes.grid.width / 2))) / 2,
    }
    isoposition.x += 1 // because why??
    isoposition.y += 1 // because why??
    isoposition.z = 0
    return isoposition
}

function raycast(stage, position) {
    let castposition = position
    Keyset.forEach(stage.world.terrain, (terrain) => {
        if(terrain.position.z == 0) {
            return
        }
        const superposition = {
            "x": Math.floor(position.x + terrain.position.z),
            "y": Math.floor(position.y + terrain.position.z),
            "z": terrain.position.z // assuming position.z should be... zero? so we don't add it
        }
        if(superposition.x == terrain.position.x
        && superposition.y == terrain.position.y
        && terrain.shape != "obstruction") { // TODO: why is this hardcoded here?
            castposition = superposition
        }
        // if(block.shape == "south-ramp") {
        //     // console.log(position, block.position)
        //     const z = block.position.z // anchored at bottom, no block.size.z
        //     const raisedposition = {
        //         "x": position.x + z,
        //         "y": position.y + z,
        //         "z": z // this effectively raises everything by one for our example ramp.
        //     }
        //     const rampedposition = {
        //         "x": raisedposition.x,
        //         "y": raisedposition.y,
        //         "z": raisedposition.z,
        //     }
        //     if(block.position.x > raisedposition.x
        //     && block.position.x - raisedposition.x < 1) {
        //         rampedposition.x += block.position.x - raisedposition.x
        //         rampedposition.z += block.position.x - raisedposition.x
        //     }
        //     if(block.position.y > raisedposition.y
        //     && block.position.y - raisedposition.y < 1) {
        //         rampedposition.y += block.position.y - raisedposition.y
        //         rampedposition.z += block.position.y - raisedposition.y
        //     }
        //     if(Math.floor(rampedposition.x) == block.position.x
        //     && Math.floor(rampedposition.y) == block.position.y) {
        //         // console.log(block.position)
        //         castposition = {
        //             "x": Math.floor(rampedposition.x),
        //             "y": Math.floor(rampedposition.y),
        //             "z": raisedposition.z + block.size.z,
        //         }
        //     }
        //     // console.log(raisedposition, block.position)
        // }
    })
    return castposition
}

export default class Selection {
    constructor(that) {
        this.encounter = that.encounter

        this.selectedUnitKey = undefined
        this.hoveredUnitKey = undefined
        this.hoveredAction = undefined

        this.position = {"x": 0, "y": 0}
        this.previousPositions = []

        this.camera = {
            "position": {
                "x": Math.round(sizes.canvas.width / 2),
                "y": Math.round((sizes.canvas.height / 3)) + 50,
            }
        }
    }
    update(delta) {
        this.position = calculateRelativePosition(Pointer.position, this.camera)
        this.position = convertCartesianToIsometric(this.position)
        this.position = raycast(this.encounter.stage, this.position)

        if(Pointer.wasJustPressed("auxiliary", true, delta.ms)) {
            clipboard(this.position.x + "x" + this.position.y)
            console.log(">", this.position.x + "x" + this.position.y)
        }

        let isNewlyHovered = false
        if(this.previousPositions[0] == undefined
        || this.previousPositions[0].x != this.position.x
        || this.previousPositions[0].y != this.position.y) {
            this.previousPositions.unshift({"x": this.position.x, "y": this.position.y, "z": this.position.z})
            if(this.previousPositions.length > MAXIMUM_HOVERED_POSITIONS) {
                this.previousPositions.pop()
            }
            isNewlyHovered = true
        }

        this.hoveredUnitKey = (Stage.findUnitByPosition(this.encounter.stage, this.position) || {}).key

        if(this.canAction(this.selectedUnitKey, this.encounter.stage)) {
            this.hoveredAction = this.findAction(this.position, this.selectedUnit)
        } else {
            this.hoveredAction = undefined
        }

        if(this.hoveredAction != undefined
        && this.hoveredAction.omegastage.nextTurn == undefined) {
            const mark = Speedtest.mark("Actions", "Selection.update")
            Stage.calculateNextTurn(this.hoveredAction.omegastage)
            mark()//.log({"maximum": 100})
        }

        if(Pointer.wasJustPressed("primary", true, delta.ms)) {
            this.start()
        }
        if(Pointer.wasJustPressed("primary", false, delta.ms)) {
            this.finish()
        }
        if(Keyb.wasJustPressed("<escape>", delta.ms)
        || Pointer.wasJustPressed("secondary", true, delta.ms)) {
            this.cancel()
        }

        if(this.selectedUnit != undefined
        && this.selectedUnit.skills != undefined) {
            this.selectedUnit.skills.forEach((skillKey, index) => {
                if(Keyb.wasJustPressed(index + 1)) {
                    this.selectedSkillKey = skillKey
                }
            })
        }

        if(isNewlyHovered == true) {
            if(this.selectedUnitKey != undefined
            && this.hoveredAction != undefined) {
                Audiomix.trigger("Selection:Move")
            } else if(this.hoveredUnitKey != undefined) {
                Audiomix.trigger("Selection:Move")
            }
        }
    }
    start() {
        if(this.selectedUnitKey == undefined) {
            if(this.canSelect(this.hoveredUnitKey)) {
                this.selectedUnitKey = this.hoveredUnitKey
                this.selectedTime = Date.now()
                Audiomix.trigger("Selection:Start")
                // console.log("START")
            }
        } else if(this.selectedUnitKey != undefined) {
            if(this.hoveredAction != undefined
            && Action.isNothing(this.hoveredAction) != true) {
                return
            }
            // You click on another selectable unit, you select
            // that unit instead. Note that this is blocked by
            // action tiles, so it'd rather invoke a selected
            // skill on that unit rather than select it.
            if(this.hoveredUnitKey != undefined
            && this.hoveredUnitKey != this.selectedUnitKey
            && this.canSelect(this.hoveredUnitKey)) {
                // console.log("RESTART")
                this.selectedUnitKey = this.hoveredUnitKey
                this.selectedTime = Date.now()
                this.selectedSkillKey = undefined
                Audiomix.trigger("Selection:Start")
                return
            }
        }
    }
    finish() {
        if(this.selectedUnitKey != undefined //) {
        && Date.now() - this.selectedTime >= MINIMUM_SELECTION_DURATION) {
            // // You click on a unit to select it, you click on a unit
            // // again to unselect it. This is important for mobile.
            // if(this.selectedUnitKey == this.hoveredUnitKey) {
            //     // console.log("CANCEL: ON SELF")
            //     this.selectedUnitKey = undefined
            //     this.selectedTime = undefined
            //     Audiomix.trigger("Selection:Cancel")
            //     return
            // }
            // You click on an action tile, you perform that action.
            if(this.hoveredAction != undefined
            && Action.isNothing(this.hoveredAction) != true) {
                // console.log("FINISH")
                // console.log("Selected Action", this.hoveredAction)
                const omegastage = this.encounter.performAction(this.hoveredAction)
                this.hoveredAction = undefined
                this.selectedSkillKey = undefined
                if(this.canSelect(this.selectedUnitKey, omegastage) == false) {
                    this.selectedUnitKey = undefined
                    this.selectedTime = undefined
                }
                Audiomix.trigger("Selection:Finish")
                return
            }
            // You click on another selectable unit, you select
            // that unit instead. Note that this is blocked by
            // action tiles, so it'd rather invoke a selected
            // skill on that unit rather than select it.
            if(this.hoveredUnitKey != undefined
            && this.canSelect(this.hoveredUnitKey)) {
                // console.log("RESTART")
                this.hoveredAction = undefined
                this.selectedUnitKey = this.hoveredUnitKey
                this.selectedTime = Date.now()
                this.selectedSkillKey = undefined
                Audiomix.trigger("Selection:Start")
                return
            }
            // You click where there are no units or
            // action tiles, you unselect the unit.
            if(this.hoveredAction == undefined
            || Action.isNothing(this.hoveredAction) == true) {
                // console.log("CANCEL: ON NOTHING")
                this.hoveredAction = undefined
                this.selectedUnitKey = undefined
                this.selectedTime = undefined
                this.selectedSkillKey = undefined
                Audiomix.trigger("Selection:Cancel")
            }
        }
    }
    cancel() {
        if(this.selectedSkillKey != undefined) {
            this.hoveredAction = undefined
            this.selectedSkillKey = undefined
        } else if(this.selectedUnitKey != undefined) {
            this.hoveredAction = undefined
            this.selectedUnitKey = undefined
            this.selectedTime = undefined
        }
        Audiomix.trigger("Selection:Cancel")
    }
    reset() {
        this.selectedUnitKey = undefined
        this.selectedSkillKey = undefined
        this.selectedTime = undefined
    }
    isSelected(unit) {
        return unit != undefined
            && this.selectedUnitKey == unit.key
    }
    canSelect(unitKey, stage) {
        stage = stage || this.encounter.stage
        const unit = stage.units[unitKey]
        return unitKey != undefined
            && unit != undefined
            && unit.isDead != true
            // && unit.affiliation == this.encounter.player.affiliation
    }
    canAction(unitKey, stage) {
        stage = stage || this.encounter.stage
        const unit = stage.units[unitKey]
        return unitKey != undefined
            && unit != undefined
            && unit.affiliation == this.encounter.player.affiliation
    }
    canSelectUnitSkill(unit, skill) {
        return unit != undefined
            && unit.energy["invoke skill"] == true
    }
    get selectedUnit() {
        return this.encounter.stage.units[this.selectedUnitKey]
    }
    get hoveredUnit() {
        return this.encounter.stage.units[this.hoveredUnitKey]
    }
    get activeUnitKey() {
        return this.hoveredUnitKey || this.selectedUnitKey
    }
    get activeUnit() {
        return this.selectedUnit || this.hoveredUnit
    }
    mode(unit) {
        if(unit == undefined) {
            return "none"
        }
        if(unit.energy["move"] == false
        && unit.energy["invoke skill"] == true) {
            return "invoke skill only"
        } else if(unit.energy["move"] == true) {
            return "move only"
        }
        return "none"
    }
    // get mode() {
    //     if(this.selectedUnitKey != undefined
    //     && this.selectedSkillKey != undefined) {
    //         return "invoke skill only"
    //     } else {
    //         return "move and invoke skill"
    //     }
    // }
    findAction(position, unit) {
        unit = unit || this.selectedUnit

        if(unit == undefined
        || unit.actionmap == undefined
        || unit.actionmap[position.x + "x" + position.y + "x" + position.z] == undefined
        || unit.actionmap[position.x + "x" + position.y + "x" + position.z] instanceof Array == false) {
            return
        }
        const actionlist = unit.actionmap[position.x + "x" + position.y + "x" + position.z].filter((action) => {
            if(this.mode(unit) == "invoke skill only") {
                return action.type == "invoke skill"
                    // && action.skillKey == this.selectedSkillKey
                    // && Geometry.equals(action.positions[1], unit.position)
            }
            if(this.mode(unit) == "move only") {
                return action.type == "move"
                    // || action.type == "move through"
                    // || action.type == "move through"
                    || action.type == "wait-for-move"
                    || action.type == "wait-for-attack"
            }
            if(this.mode(unit) == "move and invoke skill") {
                return true
            }
        })
        actionlist.sort((a, b) => {
            // console.log(a.distance, b.distance)
            if(a.distance < b.distance) return -1
            if(a.distance > b.distance) return +1
        })
        const moveAction = actionlist.find((action) => {
            return action.type == "move"
                // || action.type == "wait"
                || action.type == "wait-for-move"
                || action.type == "wait-for-attack"
        })
        if(moveAction != undefined) {
            return moveAction
        }
        let preferredRecentActions = actionlist.map((action) => {
            action.recentlyHoveredScore = Infinity
            if(action.type == "move through"
            || action.type == "no move") {
                return action
            }
            if(action.positions != undefined
            && action.positions.length > 1) {
                for(let index in this.previousPositions) {
                    let previousPosition = this.previousPositions[index]
                    if(Geometry.equals(previousPosition, action.positions[1])) {
                        action.recentlyHoveredScore = index
                        return action
                    }
                }
            }
            // if(action.type == "move") {
            //     action.recentlyHoveredScore = -10
            // }
            return action
        }).sort((a, b) => {
            if(a.recentlyHoveredScore < b.recentlyHoveredScore) return -1
            if(a.recentlyHoveredScore > b.recentlyHoveredScore) return +1
            return 0
        })
        if(preferredRecentActions[0] != undefined) {
            return preferredRecentActions[0]
        }
    }
}

class Action {
    static isNothing(action) {
        if(action.type == "no move"
        // || action.type == "wait"
        || action.type == "move through") {
            return true
        }
        const performer = action.alphastage.units[action.performerKey]
        if(action.type == "move"
        && performer.position.x == action.position.x
        && performer.position.y == action.position.y
        && performer.position.z == action.position.z) {
            return true
        }
    }
}
